export const VerifyTOTPButton = (bm, category, label, type) => {
  bm.add(type, {
    label: `<i class="webconnect-shield-lock-fill"></i><div>${label}</div>`,
    category: category,
    content: `<form class="form dc-form-default dc-form-bordered" onsubmit="return verificationprocess(event)" data-gjs-type="verify-totp" data-js="verify-totp">
    <div class="col-12 col-md-12">
      <h4 class="title">Verify Two Factor Authentication</h4>
    </div>
    <div class="form-container row mx-auto" draggable="false" data-gjs-copyable="false" data-gjs-selectable="true" data-gjs-custom-name="Form Container">
      <div class="alert alert-danger alert-message" style="display: none"></div>
      <div class="alert alert-success success-message" style="display: none"></div>
      <div class="form-group col-12 col-md-12">
        <label for="verify_code">Verification Code:</label>
        <input type="text" name="verify_code" class="form-control" required placeholder="Verification Code" id="verify_code">
      </div>
      <div class="form-group p-t-10 no-border-bottom col-12 col-md-12">
        <button type="submit" class="btn btn-primary">Verify</button>                
      </div>
    </div>
  </form>`,
  });
};

export default (dc, label, type, config) => {
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { projectId, collections } = config;

  const isComponent = {
    isComponent(el) {
      if (el.getAttribute && el.getAttribute('data-gjs-type') == type) {
        return {
          type: type,
        };
      }
    },
  };

  const newModel = {
    defaults: {
      ...defaultModel.prototype.defaults,
      name: 'Verification Form',
      droppable: ':not(form)',
      draggable: ':not(form)',
      icon: '<i class="wb webconnect-shield-lock-fill"></i>',
      projectId,
      traits: [
        {
          type: 'webconnect-event',
          label: false,
          name: 'onsubmit',
        },
        ...dc.getType('default').model.prototype.defaults.traits,
      ],
    },
    init() {
      const usernameComponent = this.findType('input');
      usernameComponent.forEach((comp) => {
        const attr = comp.getAttributes();
        if (['verify_code', 'verifycode'].includes(attr.name)) {
          attr.name = 'verify_code';
          comp.setAttributes(attr);
        }
      });
    },
  };

  const extendModel = defaultModel.extend(newModel, isComponent);
  dc.addType(type, {
    model: extendModel,
    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
      init({ model }) {},
    }),
  });
};
